import { API } from '@/api/API';
import { applyCartCodes } from '@/api/Cart';
import store from '@/store/store';
const userErrorCodes = new Set([
    'code_exhausted',
    'code_not_found',
    'additional_info_validation_failed',
    'validation_failed',
    'invalid_citypass',
    'citypass_failure',
    'no_code_benefit',
]);
export function userShouldTryAnotherPromoCode(error) {
    return userErrorCodes.has(error?._code);
}
export function applyPromoCode(code) {
    return applyPromoCodes({
        codes: [code],
        // API will only apply the code if it yields a benefit.
        // TODO Come up with better names for applyPromoCode() and applyOptionalPromoCode().
        require_benefit: true,
    });
}
export function applyOptionalPromoCode(code) {
    return (applyPromoCodes({ codes: [code] })
        // Ignore errors.
        .catch(() => null));
}
function applyPromoCodes(payload) {
    return applyCartCodes(store.getters['Cart/cart'].id, payload)
        .then((response) => store.commit('Cart/apiResponse', response))
        .catch((e) => {
        const errors = e.response?.data?._data;
        const first = errors?.[0];
        if (first?._code === 'duplicate_code') {
            // Ignore duplicate_code errors.
            if (errors?.[1]) {
                // Return next error.
                throw errors[1];
            }
            else {
                // Fake success if a promo code can not be applied because it has already been applied,
                // and there are no other errors.
                return first;
            }
        }
        else if (userShouldTryAnotherPromoCode(first)) {
            throw first;
        }
        else {
            throw e;
        }
    });
}
export function fetchCartMod(code, options) {
    const query = {};
    if (options?.includeCodeLookup) {
        query.mode = 'advertise,code';
    }
    if (options?.eventSessionId) {
        query.event_session_id = options.eventSessionId;
    }
    if (options?.ticketTypeIds?.length) {
        query.ticket_type_ids = options.ticketTypeIds.join(',');
    }
    const args = Object.keys(query).length > 0 ? { query } : undefined;
    return API.getCached(`code/${encodeURIComponent(code)}`, args);
}
